import { BypassCheck } from "../Exemptions/exemptions.types";
import { isBypassCheck } from "../Exemptions/Exemptions.utils";
import type { Collection } from "@/types/api";

export type Email = {
  ingress_id: string;
  created_at: string;
  subject: string;
  recipient: string;
  sender: string;
  ui_flag_reason: string;
  ui_status: string;
  sender_ip: string;
  customer_name?: string;
};

export type EmailSearchMode = "free_text";

export type EmailSortApplied =
  "relevance" | "created_at" | "recipient" | "sender" | "customer_name";

export type EmailSearchMeta = {
  mode: EmailSearchMode;
  sort_applied: EmailSortApplied;
};

export type EmailSearchCollection = Collection<Email> & EmailSearchMeta;

export type EmailSearchState = Collection<Email> & Partial<EmailSearchMeta>;

export type EmailDetailsDTO = {
  ingress_uuid: string;
  created_at: string;
  subject: string;
  recipient: string;
  sender: string;
  ui_flag_reason: string;
  ui_status: string;
  envelope_from?: string;
  header_from?: string;
  sender_ip: string;
  internet_messageid: string;
  virus_infection: boolean;
  quarantined: boolean;
  skipped_checks?: string[];
};

export type EmailDetails = {
  ingress_uuid: string;
  created_at: string;
  subject: string;
  recipient: string;
  sender: string;
  ui_flag_reason: string;
  ui_status: string;
  envelope_from?: string;
  header_from?: string;
  sender_ip: string;
  internet_messageid: string;
  virus_infection: boolean;
  quarantined: boolean;
  bypassChecks?: BypassCheck[];
};

export enum UiStatus {
  AUTO_REMEDIATED = "Auto Remediated",
  REMEDIATED = "Remediated",
  MARKED_AS_SAFE = "Marked as Safe",
  BANNER_APPLIED = "Banner Applied",
  ACTION_NEEDED = "Action Needed",
  DELIVERED = "Delivered",
  RELEASED = "Released",
  DELETED = "Deleted",
  QUARANTINED = "Quarantined",
  REJECTED = "Rejected",
  UNDELIVERABLE = "Undeliverable",
  DEFERRED = "Deferred",
}

export const mapEmailDetailsDTO = (dto: EmailDetailsDTO): EmailDetails => ({
  ...dto,
  ui_status: dto.ui_status || UiStatus.DELIVERED,
  bypassChecks: dto.skipped_checks?.filter(isBypassCheck),
});

export type EmailQuarantineAction = "release" | "delete";
export type EmailStatusAction = "junk" | "safe";

export enum UiVerdict {
  AUTHENTICATION_FAILURE = "Mail Authentication Failure",
  BANNED_ATTACHMENT = "Banned Attachment",
  CLEAN = "Clean",
  FRAUD = "Fraud",
  GEOBLOCKED = "Geoblocked",
  MALICIOUS = "Malicious Intent",
  MALICIOUS_LINKS = "Malicious Links",
  MALWARE = "Malware",
  PHISHING = "Phishing",
  SPAM = "Spam",
  SPOOFED = "Spoofed Display Name",
  SUSPICIOUS = "Suspicious Intent",
  SUSPICIOUS_TEXT = "Suspicious Text",
  USER_REPORTED_CLEAN = "User Reported Clean",
  USER_REPORTED_PHISHING = "User Reported Phishing",
  BLOCK_LISTED = "Block Listed",
  GRAYMAIL = "Graymail",
  USER_REPORTED_SPAM = "User Reported Spam",
  FREQ_EXPLOITED_DOMAIN = "Freq. Exploited Domain",
  RBL_BLOCKED = "RBL Blocked",
}
